import type { OfflineDb } from '../infrastructure/dexie/offline-db.js';

/**
 * Live count of outbox items still awaiting sync — used to warn/confirm
 * before sign-out (task 3.7). Real query against the Dexie outbox table
 * created in this slice; nothing writes to that table until slice 6's
 * checkin-enqueue lands, so this always returns 0 today — that is the
 * CORRECT behavior for now, not a stub that slice 6 needs to remember to
 * swap out.
 */
export function getPendingOutboxCount(db: OfflineDb): Promise<number> {
  return db.outbox.where('state').equals('pending').count();
}
